import React from 'react';
import styled from 'styled-components';
import { getImage } from 'gatsby-plugin-image';
import BackgroundImage from 'gatsby-theme-core/src/components/background-image';
import Image from 'gatsby-theme-core/src/components/image';
import Container from 'gatsby-theme-core/src/components/container';

import Title from './title';
import Article from './article';
import Content from './content';
import Button from './button';

const getWrapper = ({
  title,
  fullWidth,
  backgroundImage,
}) => {
  if (fullWidth) {
    const FullWithComponent = (props) => (
      <BackgroundImage
        image={backgroundImage}
        alt={title}
        Tag="section"
        loading="eager"
        {...props}
      />
    );
    return FullWithComponent;
  }
  const SectionComponent = (props) => <section {...props} />;
  return SectionComponent;
};

const Intro = ({
  className,
  title,
  content,
  image,
  backgroundImage,
  form,
  button,
  contentAs = 'p',
  fullWidth = false,
}) => {
  const Wrapper = getWrapper({ title, fullWidth, backgroundImage });
  return (
    <Wrapper className={className}>
      <StyledContainer>
        {!fullWidth && getImage(image?.localFile) && (
          <StyledImg
            image={image}
            alt={title}
            loading="eager"
          />
        )}
        {(title || content?.childMarkdownRemark?.html || form || button?.link) && (
          <Article $fullWidth={fullWidth}>
            {title && (
              <Title>{title}</Title>
            )}
            {content?.childMarkdownRemark?.html && (
              <StyledContent as={contentAs} $content={content} />
            )}
            {form && <FormWrapper>{form}</FormWrapper>}
            {button?.link && (
              <div>
                <Button
                  $fullWidth={fullWidth}
                  variant={button.variant || 'primary'}
                  to={button.link}
                >
                  {button.text}
                </Button>
              </div>
            )}
          </Article>
        )}

      </StyledContainer>
    </Wrapper>
  );
};

const StyledContent = styled(Content)`
  img {
     max-width: 50%;
  }
`;

const StyledContainer = styled(Container)`
  position: relative;
  padding: 0;
`;

const StyledImg = styled(Image)`
  min-height: 230px;
`;

const FormWrapper = styled.div`
  form {
    button {
      padding-left: .5rem;
      padding-right: .5rem;
      @media all and (min-width: ${(props) => props.theme.breakingpoints.lg}) {
        padding-left: 1rem;
        padding-right: 1rem;
      }
    }
  }
`;

export default styled(Intro)``;
